import { gql } from '@apollo/client';
import Fragments from './fragments';

export const FINANCIAL_INDICATOR_QUERY = gql`
  query financialIndicator($id: Int!) {
    financialIndicator(id: $id) {
      ...financialIndicatorItem
    }
  }
  ${Fragments.financialIndicatorItem}
`;

export const FINANCIAL_INDICATORS_STYLES_QUERY = gql`
  query financialIndicatorStyles {
    financialIndicatorStyles {
      id
      code
      name
    }
  }
`;
